import React, { Component } from "react"
import {
  Alert, Row, Col, Card, CardBody, CardTitle, CardSubtitle, Modal, Button, Table, FormGroup, Input, Label, Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CardText,
  Collapse,
  ButtonDropdown,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  ListGroup, ListGroupItem
} from "reactstrap";
// import classnames from "classnames"
import MetaTags from 'react-meta-tags';
import axios from 'axios';
// availity-reactstrap-validation
import { AvField, AvForm, AvGroup, AvInput, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import { SCH_URL } from "../../../helpers/url_helper";
// import SweetAlert from "react-bootstrap-sweetalert"
// import Switch from 'react-switch';
import Select from 'react-select';
import swal from 'sweetalert';
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import "../../../components/Common/datatables.scss"
const initialstate = {
  customActiveTab: 1,
  itempageabout: 'Manage Academic Structure | ',

  itemsubname: 'Manage Academic Structure',
  itemsubonename: 'Structure',
  tname: 'astruc',
  tdepname: 'schstruc',

  itemasubonename: 'Section',
  itembsubonename: 'Section Capacity',
  itemdescriptionname: 'Description',
  itemactionname: 'Add Section',

  allitems: [],
  relateditems: [],
  defaultValues: {},
  allmsubs: [],
  showAlert: false,
  alertType: '',
  alertText: '',

  addKeyModal: false,

  select_rooms: [{
    value: '',
    valueid: '',
    label: (<div>
      Select Room
    </div>
    ),
  }],
  select_teachers: [{
    value: '',
    label: (<div>
      Select Teacher
    </div>
    ),
  }],



};
class SchAcademicStructure extends Component {
  constructor(props) {
    super(props)
    // this.state = {}

    this.handleGetkeys = this.handleGetkeys.bind(this);
    this.addSec = this.addSec.bind(this);

    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.handleDkey = this.handleDkey.bind(this);
    this.handleRoomkey = this.handleRoomkey.bind(this);
    this.handleTTTkey = this.handleTTTkey.bind(this);
    this.handleFSkey = this.handleFSkey.bind(this);
    this.handleTeacherkey = this.handleTeacherkey.bind(this);
  }
  state = { ...initialstate };
  componentDidMount() {
    if (localStorage.schboardid) {
      this.handleGetkeys();

    } else {
      this.props.history.push('/dashboard'); //eslint-disable-line
    }



  }

  handleChange = (event) => {
    const { name, value } = event.target;
    console.log(name + ' ' + value);
    this.setState({ [name]: value });
  };
  handleGetkeys = () => {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.token,
    };
    var postData = {
      uid: localStorage.usercode,
      mitem: localStorage.schboardid,
      mmitem: localStorage.schstrucid,
      branid: localStorage.schbranchid,
    };
    const getuurl = SCH_URL + 'getschoolstructure';
    axios
      .post(getuurl, postData, {
        headers: headers,
      })
      .then((response) => {
        console.log('responce', response.data);
        if (response.status == 400) { }
        if (!response.data.error) {
          localStorage.setItem("token", response.data.token);
          console.log('allitems', response.data.allitems);
          const allrooms = [...response.data.avrooms];
          const allteachers = [...response.data.avteachers];



          this.setState({
            allitems: response.data.allitems,
            relateditems: response.data.allitems,
            allweekdays: response.data.weekdays,
            allfeetypes: response.data.feetypes,
            allnotitypes: response.data.notitypes,
            allnotiintvals: response.data.notiintvals,
            select_rooms: [{
              value: '',
              valueid: '',
              label: (<div>
                Select Room
              </div>
              ),
            }],
            select_teachers: [{
              value: '',
              label: (<div>
                Select Teacher
              </div>
              ),
            }],

          }, () => {
            if (allrooms.length >= 1) {
              allrooms.map((item) => {
                this.state.select_rooms.push({
                  value: item.itemname,
                  valueid: item.id,
                  label: (
                    <div>
                      {item.itemname}/{item.itemtwo}
                    </div>
                  ),
                });
              });
            }
            if (allteachers.length >= 1) {
              allteachers.map((item) => {
                this.state.select_teachers.push({
                  value: item.itemname,
                  label: (
                    <div>
                      {item.itemname}/{item.itemtwo}
                    </div>
                  ),
                });
              });
            }

          });
        }
      })
      .catch((error) => {
        console.log('error', error);
        // localStorage.clear();
        //this.props.history.push('/'); //eslint-disable-line
      });
  };


  handleDkey = (id, item, tble, checked) => {
    console.log(checked + 'checked');
    console.log(id + 'id');
    console.log(item + 'item');

    swal({
      title: 'Delete ' + item,
      text: 'Are you sure?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((keyconfirm) => {
      if (keyconfirm) {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: localStorage.token,
        };

        const delkeyurl = SCH_URL + 'delitem';
        var postData = {
          keyid: id,
          uid: localStorage.usercode,
          table: tble,
        };
        axios
          .post(delkeyurl, postData, {
            headers: headers,
          })
          .then((response) => {
            console.log(response.data.message);

            if (response.data.error) {
              swal(item + ' ' + response.data.message, {
                icon: 'warning',
              });
            } else {
              localStorage.setItem("token", response.data.token);
              this.handleGetkeys();
              swal(item + ' ' + response.data.message, {
                icon: 'success',
              });
            }
          })
          .catch((error) => {
            console.log('Error is ', error);
            swal('Try Again Later', {
              icon: 'warning',
            });
          });
      }
    });
  };

  handleValidSubmit = (event, values) => {
    event.preventDefault();
    console.log('values', values);
    var msecsubs = JSON.stringify(values.msecsubs);
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.token,
    };
    var addkeyurl = SCH_URL + 'addmmabitem';
    var postData = {
      itema: values.itema,
      itemb: values.itemb,
      description: values.description,
      msecsubs: msecsubs,
      mitem: this.state.mitemvalue,
      mmitem: localStorage.schstrucid,
      uid: localStorage.usercode,
      table: 'schsec',
      mtable: 'mcl',
      mmtable: 'schstruc',
      clmb: 'clmbsc',

    };
    if (this.state.editmode) {
      addkeyurl = SCH_URL + 'editmmabitem';
      postData = {
        itemid: this.state.editid,
        itema: values.itema,
        itemb: values.itemb,
        description: values.description,
        mitem: this.state.mitemvalue,
        mmitem: localStorage.schstrucid,
        uid: localStorage.usercode,
        table: 'schsec',
        mtable: 'mcl',
        mmtable: 'schstruc',
        clmb: 'clmbsc',

      };
    }

    axios
      .post(addkeyurl, postData, {
        headers: headers,
      })
      .then((response) => {
        console.log(response.data.message);
        console.log('response.data', response.data);
        if (response.data.error) {
          this.setState({
            showAlert: true,
            alertType: 'warning',
            alertText: response.data.message,
          });
        } else {
          localStorage.setItem("token", response.data.token);
          this.handleGetkeys();
          this.setState(
            {
              addKeyModal: false,
            });
          swal(values.itema + ' ' + response.data.message, {
            icon: 'success',
          });
        }
      })
      .catch((error) => {
        console.log('Error is ', error);
        this.setState({
          alertType: 'danger',
          showAlert: true,
          alertText: 'Failed Try Again Later!',
        });
      });


  };
  addSec = (id, name, msubs) => {
    const defaultValues = {
      msecsubs: [],
      itema: '',
      itemb: '',
      description: '',
    };
    console.log(id + 'id');
    console.log(name + 'name');
    console.log('msubs', msubs);
    this.setState({
      addKeyModal: true,
      addRoomModal: false,
      itemactionname: 'Add Section to ' + name,
      editmode: false,
      mitemvalue: id,
      allmsubs: msubs,
      defaultValues: defaultValues,
    });
  };
  handleEditkey = (id, itema, itemb, mitem, description, checked) => {
    console.log(checked + 'checked');
    console.log(id + 'id');
    console.log(itema + 'itema');
    console.log(itemb + 'itemb');
    console.log(mitem + 'mitem');
    console.log(description + 'description');
    const defaultValues = {
      msecsubs: [],
      itema: itema,
      itemb: itemb,
      description: description,
    };
    this.setState({
      addKeyModal: true,
      editmode: true,
      editid: id,
      mitemvalue: mitem,
      allmsubs: [],
      defaultValues: defaultValues,
      itemactionname: 'Edit ' + this.state.itemasubonename,
    });
  };


  handleCkey = () => {
    this.setState({
      addKeyModal: false,
      addRoomModal: false,
      addTeacherModal: false,
      addTTTModal: false,
      addFSModal: false,
      addTTTadd: false,
      showAlert: false,
      itemvalue: '',

    });
  };

  handleRoomkey = (id, checked) => {
    console.log(id + 'id');
    this.setState({
      addRoomModal: true,
      addTeacherModal: false,
      addKeyModal: false,
      msecid: id,
      itemactionname: 'Assign Room ',
    });
  };

  handleValidTttSubmit = (event, values) => {
    event.preventDefault();
    console.log('values', values);

    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.token,
    };
    var addkeyurl = SCH_URL + 'linkttt';
    var postData = {
      tttid: values.tttvalue,
      msecid: this.state.msecid,
      uid: localStorage.usercode,
      table: 'schsec',
    };
    if (this.state.addTTTadd) {
      addkeyurl = SCH_URL + 'addtttname';
      var weekdays = JSON.stringify(values.weekdays);
      postData = {
        tttname: values.tttname,
        description: values.description,
        weekdays: weekdays,
        msecid: this.state.msecid,
        table: 'schsectt',
        uid: localStorage.usercode,
      };
    }
    axios
      .post(addkeyurl, postData, {
        headers: headers,
      })
      .then((response) => {
        console.log(response.data.message);
        console.log('response.data', response.data);
        if (response.data.error) {
          this.setState({
            showAlert: true,
            alertType: 'warning',
            alertText: response.data.message,
          });
        } else {
          localStorage.setItem("token", response.data.token);
          if (this.state.addTTTadd) {
            localStorage.setItem('tttid', response.data.tttid);
            this.props.history.push('/timetable'); //eslint-disable-line
          } else {
            this.handleGetkeys();
            this.setState(
              {
                addTTTModal: false,
              });
            swal('Template ' + response.data.message, {
              icon: 'success',
            });
          }

        }
      })
      .catch((error) => {
        console.log('Error is ', error);
        this.setState({
          alertType: 'danger',
          showAlert: true,
          alertText: 'Failed Try Again Later!',
        });
      });


  };
  handleTTTkey = (secid, tttid, whatsup, tttlist, checked) => {
    console.log('secid', secid);
    console.log('tttid', tttid);
    console.log('whatsup', whatsup);
    console.log('tttlist', tttlist);
    const defaultTttValues = {

      tttvalue: tttid,
    };


    if (whatsup == 'Add') {

      this.setState({
        addTTTModal: true,
        addTTTadd: true,
        addTTTReAssign: false,
        addFSModal: false,
        addRoomModal: false,
        addTeacherModal: false,
        addKeyModal: false,
        msecid: secid,
        itemactionname: 'Add Time Table Template ',

      });

    } else if (whatsup == 'Edit') {

      localStorage.setItem('tttname', tttlist);
      localStorage.setItem('tttid', tttid);
      this.props.history.push('/timetable'); //eslint-disable-line

    } else if (whatsup == 'Assign') {

      if (tttlist.length >= 1) {
        this.setState({
          addTTTModal: true,
          addTTTadd: false,
          addTTTReAssign: false,
          addFSModal: false,
          addRoomModal: false,
          addTeacherModal: false,
          addKeyModal: false,
          msecid: secid,
          itemactionname: 'Assign Time Table Template ',
          defaultTttValues: defaultTttValues,
          tttlist: tttlist,
        });
      }

    }



  };

  handleFSkey = (id, checked) => {
    console.log(id + 'id');
    this.setState({
      addTTTModal: false,
      addFSModal: true,
      addRoomModal: false,
      addTeacherModal: false,
      addKeyModal: false,
      msecid: id,
      itemactionname: 'Add Fee Structure ',
    });
  };

  handleValidFSSubmit = (event, values) => {
    event.preventDefault();
  }
  handleTeacherkey = (id, checked) => {
    console.log(id + 'id');
    this.setState({
      addTeacherModal: true,
      addRoomModal: false,
      addKeyModal: false,
      secsubid: id,
      itemactionname: 'Assign Teacher ',
    });
  };

  handleValidTeacherSubmit = (event, values) => {
    event.preventDefault();
    console.log('values', values);
    if (this.state.teachervalue == '') {
      this.setState({
        showAlert: true,
        alertType: 'warning',
        alertText: 'Select Teacher',
      });
    } else {


      const headers = {
        'Content-Type': 'application/json',
        Authorization: localStorage.token,
      };
      var addkeyurl = SCH_URL + 'linkteacher';
      var postData = {
        teacherid: this.state.teachervalue,
        secsubid: this.state.secsubid,
        uid: localStorage.usercode,
        table: 'schsecsub',
      };

      axios
        .post(addkeyurl, postData, {
          headers: headers,
        })
        .then((response) => {
          console.log(response.data.message);
          if (response.data.error) {
            this.setState({
              showAlert: true,
              alertType: 'warning',
              alertText: response.data.message,
            });
          } else {
            localStorage.setItem("token", response.data.token);
            this.handleGetkeys();
            this.setState(
              {
                addTeacherModal: false,
                msecsubid: '',
                teachervalue: '',
              });
            swal('Teacher ' + response.data.message, {
              icon: 'success',
            });
          }
        })
        .catch((error) => {
          console.log('Error is ', error);
          this.setState({
            alertType: 'danger',
            showAlert: true,
            alertText: 'Failed Try Again Later!',
          });
        });

    }
  };

  handleSelectroomChange = (selectedOption) => {
    let roomvalue = selectedOption.value;
    this.setState({ roomvalue: roomvalue, roomvaluename: selectedOption.label.props.children, });
  };

  handleSelectteacherChange = (selectedOption) => {
    let teachervalue = selectedOption.value;
    this.setState({ teachervalue: teachervalue, teachervaluename: selectedOption.label.props.children, });
  };

  handleSelecttttChange = (selectedOption) => {
    let tttvalue = selectedOption.value;
    this.setState({ tttvalue: tttvalue, tttvaluename: selectedOption.label.props.children, });
  };

  handleValidRoomSubmit = (event, values) => {
    event.preventDefault();
    console.log('values', values);
    if (this.state.roomvalue == '') {
      this.setState({
        showAlert: true,
        alertType: 'warning',
        alertText: 'Select Room',
      });
    } else {


      const headers = {
        'Content-Type': 'application/json',
        Authorization: localStorage.token,
      };
      var addkeyurl = SCH_URL + 'linkroom';
      var postData = {
        roomid: this.state.roomvalue,
        secid: this.state.msecid,
        uid: localStorage.usercode,
        table: 'schsec',
      };

      axios
        .post(addkeyurl, postData, {
          headers: headers,
        })
        .then((response) => {
          console.log(response.data.message);
          if (response.data.error) {
            this.setState({
              showAlert: true,
              alertType: 'warning',
              alertText: response.data.message,
            });
          } else {
            localStorage.setItem("token", response.data.token);
            this.handleGetkeys();
            this.setState(
              {
                addRoomModal: false,
                msecid: '',
                roomvalue: '',
              });
            swal('Room ' + response.data.message, {
              icon: 'success',
            });
          }
        })
        .catch((error) => {
          console.log('Error is ', error);
          this.setState({
            alertType: 'danger',
            showAlert: true,
            alertText: 'Failed Try Again Later!',
          });
        });

    }
  };


  render() {

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>{this.state.itempageabout}{localStorage.boardname} </title>
          </MetaTags>
          <div className="container-fluid">
            <Breadcrumbs title={localStorage.acaboardname} breadcrumbItem={this.state.itemsubname} />


            <Card>
              <CardBody>
                <p className="card-title-desc onclicklink" onClick={() => {
                  this.props.history.push('/dashboard'); //eslint-disable-line
                }}>Back to Boards</p>




                {this.state.relateditems &&
                  this.state.relateditems.map((mitem, schindex) => {

                    return (
                      <div key={schindex}>
                        {mitem.structure_dtls && mitem.structure_dtls.map((mcat, mcatindex) => {


                          return (
                            <div className="col-md-12" key={mcatindex}>
                              <Card className="catcard">
                                <CardBody>
                                  <CardTitle className="h4">{mcat.mcatname}

                                  </CardTitle>

                                </CardBody>
                              </Card>


                              {mcat.mcls.length >= 1 ? (

                                <>
                                  {mcat.mcls && mcat.mcls.map((mclass, mclsindex) => {


                                    return (
                                      <Card key={mclsindex}>
                                        <CardBody>
                                          <div className="row">
                                            <div className="col-md-1">
                                              <span className="as-class clearfix"><i className="mdi mdi-chevron-right" />  {mclass.mclname}


                                              </span>
                                              {mclass.clsubs.length >= 1 ? (
                                                <>
                                                  {mclass.clsubs && mclass.clsubs.map((msub, index) => {
                                                    return (
                                                      <span key={index}>
                                                        <span className="as-subject"><i className="mdi mdi-chevron-double-right" />  {msub.msubname}</span><br />

                                                      </span>
                                                    )
                                                  })}
                                                </>
                                              ) : "No Subjects"}
                                              <Button
                                                className="btn-sm xmart10"
                                                color="success"
                                                onClick={this.addSec.bind(this, mclass.acclid, mclass.mclname, mclass.clsubs)}
                                              >
                                                <i className="mdi mdi-plus" /> Section
                                              </Button>
                                            </div>
                                            <div className="col-md-11">



                                              <div className="table-responsive">
                                                <Table className="table mb-0">
                                                  <thead>
                                                    <tr>
                                                      <th>#</th>
                                                      <th style={{ width: '100px' }}>{this.state.itemasubonename}/Capacity</th>
                                                      {/* <th>Room Name/Capacity</th>
                                                      <th>Fee Structure</th>
                                                      <th>Time Table Template</th> */}
                                                      <th>Subjects <i className="mdi mdi-chevron-double-right" /> Teacher</th>

                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {mclass.clsections &&
                                                      mclass.clsections.map((msec, secindex) => {


                                                        return (
                                                          <tr key={secindex}>
                                                            <th scope="row">{secindex + 1}</th>
                                                            <td>

                                                              <span className="as-subject">
                                                                <span className="xmarr10 onclicklink" onClick={this.handleEditkey.bind(
                                                                  this,
                                                                  msec.secid,
                                                                  msec.secname,
                                                                  msec.capex,
                                                                  mclass.acclid,
                                                                  msec.description,
                                                                )}><i className="bx bx-pencil font-size-16 align-middle ms-1" /></span><b>{msec.secname}</b> / {msec.capex}
                                                                {msec.roomid == 0 ? (

                                                                  <span className="xmarl10 onclicklink" onClick={this.handleDkey.bind(
                                                                    this,
                                                                    msec.secid,
                                                                    msec.secname,
                                                                    'schsec'
                                                                  )}><i className="bx bx-trash font-size-16 align-middle ms-1" /></span>

                                                                ) : null}</span><br />
                                                              <span className="as-subject descp"><b>Desc: </b>{msec.description}</span>

                                                            </td>

                                                            <td>
                                                              {msec.secsubs.length >= 1 ? (
                                                                <>
                                                                  {msec.secsubs && msec.secsubs.map((secsub, secsubindex) => {
                                                                    return (
                                                                      //msubid, msubname
                                                                      <Row key={secsubindex} className="as-subject">
                                                                        <Col className="col-4">
                                                                          <span
                                                                            className="xmarr10 onclicklink"
                                                                            onClick={this.handleDkey.bind(
                                                                              this,
                                                                              secsub.secsubid,
                                                                              secsub.secsubname,
                                                                              'schsecsub'
                                                                            )}><i className="bx bx-trash font-size-16 align-middle ms-1" /></span>
                                                                          <i className="mdi mdi-chevron-double-right" />
                                                                          {secsub.secsubname}

                                                                        </Col>
                                                                        <Col key={secsubindex} className="col-8">
                                                                          {secsub.secsubteaid >= 1 ? (
                                                                            <>
                                                                              <i className="mdi mdi-chevron-double-right" />
                                                                              {secsub.secsubteaname}
                                                                              <span
                                                                                className="xmarl10"
                                                                                color="primary" onClick={this.handleTeacherkey.bind(this, secsub.secsubid)}><i className="bx bx-pencil font-size-16 align-middle ms-1" />  </span>
                                                                            </>
                                                                          ) : (
                                                                            <button
                                                                              className="btn btn-warning btn-sm"
                                                                              color="primary" onClick={this.handleTeacherkey.bind(this, secsub.secsubid)}><i className="bx bx-plus font-size-16 align-middle ms-1" /> Teacher to {secsub.secsubname}</button>
                                                                          )}
                                                                        </Col>


                                                                      </Row>


                                                                    )
                                                                  })}
                                                                </>
                                                              ) : "No Section Subjects"}


                                                            </td>

                                                          </tr>
                                                        );
                                                      })}

                                                  </tbody>
                                                </Table>
                                              </div>

                                            </div>
                                          </div>
                                        </CardBody>
                                      </Card>
                                    )
                                  })}
                                </>

                              ) : (
                                <Card>
                                  <CardBody>
                                    <div className="row">
                                      <div className="col-md-2">
                                        No Classes
                                      </div>
                                      <div className="col-md-10">No Subjects</div>
                                    </div>
                                  </CardBody>
                                </Card>

                              )}



                            </div>
                          )
                        })}
                      </div>
                    );
                  })}


              </CardBody>
            </Card>

          </div>
          <Modal
            isOpen={this.state.addKeyModal}

            centered={true}
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0">{this.state.itemactionname} </h5>
              <button
                type="button"
                onClick={this.handleCkey}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">


              <AvForm
                className="needs-validation"
                onValidSubmit={this.handleValidSubmit} model={this.state.defaultValues}
              >
                {this.state.showAlert ? (
                  <Alert color={this.state.alertType}>
                    <p>{this.state.alertText}</p>
                  </Alert>
                ) : null}


                <div className="mb-3">
                  <AvField
                    name="itema"
                    label={this.state.itemasubonename}
                    type="text"
                    required
                    placeholder={'Enter ' + this.state.itemasubonename}
                  />
                </div>
                <div className="mb-3">
                  <AvField
                    name="itemb"
                    label={this.state.itembsubonename}
                    required
                    placeholder={'Enter ' + this.state.itembsubonename}
                    type="number"
                    errorMessage="Enter Only Number"
                    validate={{
                      required: { value: true },
                      pattern: {
                        value: "^[0-9]+$",
                        errorMessage: "Only Numbers",
                      },
                    }}
                  />

                </div>

                <div className="mb-3">
                  <AvField
                    name="description"
                    label={this.state.itemdescriptionname}
                    type="text"
                    // required
                    placeholder={'Enter ' + this.state.itemdescriptionname}
                  />

                </div>
                {this.state.editmode ? null : (
                  <div className="mb-3">
                    <AvCheckboxGroup name="msecsubs" label="Select Subjects" required>
                      {this.state.allmsubs && this.state.allmsubs.map((allmsub, index) => {
                        return (
                          <AvCheckbox key={index} label={allmsub.msubname} value={allmsub.msubid} />
                        )
                      })}
                    </AvCheckboxGroup>
                  </div>
                )}
                <div className="mt-4 d-grid">
                  <button
                    className="btn btn-primary btn-block waves-effect waves-light"
                    type="submit"
                  >
                    {this.state.itemactionname}
                  </button>
                </div>


              </AvForm>
            </div>
          </Modal>

          <Modal
            isOpen={this.state.addRoomModal}

            centered={true}
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0">{this.state.itemactionname} </h5>
              <button
                type="button"
                onClick={this.handleCkey}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">



              <AvForm
                className="needs-validation"
                onValidSubmit={this.handleValidRoomSubmit}
              >
                {this.state.showAlert ? (
                  <Alert color={this.state.alertType}>
                    <p>{this.state.alertText}</p>
                  </Alert>
                ) : null}

                {/* schstrucid */}

                <div className="mb-3">
                  <div className="form-group">
                    <label className="">Rooms</label>
                    <div className="form__form-group-field" style={{ height: '30px' }}>
                      <Select
                        name="roomvalue"
                        value={this.state.select_rooms.filter(
                          (option) => option.value == this.state.roomvalue,
                        )}
                        onChange={this.handleSelectroomChange}
                        options={this.state.select_rooms}
                        clearable={false}
                        className="react-select-team"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                </div>






                <div className="mt-4 d-grid">

                  <button
                    className="btn btn-primary btn-block waves-effect waves-light"
                    type="submit" style={{ marginTop: '18px' }}
                  >
                    {this.state.itemactionname}
                  </button>
                </div>


              </AvForm>

            </div>
          </Modal>
          <Modal
            isOpen={this.state.addTeacherModal}

            centered={true}
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0">{this.state.itemactionname} </h5>
              <button
                type="button"
                onClick={this.handleCkey}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">



              <AvForm
                className="needs-validation"
                onValidSubmit={this.handleValidTeacherSubmit}
              >
                {this.state.showAlert ? (
                  <Alert color={this.state.alertType}>
                    <p>{this.state.alertText}</p>
                  </Alert>
                ) : null}

                {/* schstrucid */}

                <div className="mb-3">
                  <div className="form-group">
                    <label className="">Teacher / Employee ID</label>
                    <div className="form__form-group-field" style={{ height: '30px' }}>
                      <Select
                        name="teachervalue"
                        value={this.state.select_teachers.filter(
                          (option) => option.value == this.state.teachervalue,
                        )}
                        onChange={this.handleSelectteacherChange}
                        options={this.state.select_teachers}
                        clearable={false}
                        className="react-select-team"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                </div>






                <div className="mt-4 d-grid">

                  <button
                    className="btn btn-primary btn-block waves-effect waves-light"
                    type="submit" style={{ marginTop: '18px' }}
                  >
                    {this.state.itemactionname}
                  </button>
                </div>


              </AvForm>

            </div>
          </Modal>

          <Modal
            isOpen={this.state.addTTTModal}

            centered={true}
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0">{this.state.itemactionname} </h5>
              <button
                type="button"
                onClick={this.handleCkey}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">






              {this.state.addTTTadd ? (
                <AvForm
                  className="needs-validation"
                  onValidSubmit={this.handleValidTttSubmit}
                >
                  {this.state.showAlert ? (
                    <Alert color={this.state.alertType}>
                      <p>{this.state.alertText}</p>
                    </Alert>
                  ) : null}


                  <div className="mb-3">
                    <AvField
                      name="tttname"
                      label="Template Name"
                      type="text"
                      required
                      placeholder={'Enter Template Name'}
                    />
                  </div>


                  <div className="mb-3">
                    <AvField
                      name="description"
                      label={this.state.itemdescriptionname}
                      type="text"
                      // required
                      placeholder={'Enter ' + this.state.itemdescriptionname}
                    />

                  </div>

                  <div className="mb-3">
                    <AvCheckboxGroup name="weekdays" label="Select Week Days" required>
                      {this.state.allweekdays && this.state.allweekdays.map((weekday, index) => {
                        return (
                          <AvCheckbox key={index} label={weekday.name} value={weekday.id} />
                        )
                      })}
                    </AvCheckboxGroup>
                  </div>

                  <div className="mt-4 d-grid">
                    <button
                      className="btn btn-primary btn-block waves-effect waves-light"
                      type="submit"
                    >
                      {this.state.itemactionname}
                    </button>
                  </div>


                </AvForm>

              ) : (

                <AvForm
                  className="needs-validation"
                  onValidSubmit={this.handleValidTttSubmit}
                  model={this.state.defaultTttValues}
                >
                  {this.state.showAlert ? (
                    <Alert color={this.state.alertType}>
                      <p>{this.state.alertText}</p>
                    </Alert>
                  ) : null}


                  <div className="mb-3">
                    <div className="form-group">
                      <AvField type="select" name="tttvalue" label="Time Table Templates" required>
                        {this.state.tttlist && this.state.tttlist.map((ttt, index) => {
                          return (

                            <option key={index} value={ttt.tttid}>{ttt.tttname}</option>
                          )
                        })}


                      </AvField>
                    </div>

                  </div>







                  <div className="mt-4 d-grid">

                    <button
                      className="btn btn-primary btn-block waves-effect waves-light"
                      type="submit" style={{ marginTop: '18px' }}
                    >
                      {this.state.itemactionname}
                    </button>
                  </div>


                </AvForm>
              )}

            </div>
          </Modal>

          <Modal
            isOpen={this.state.addFSModal}

            centered={true}
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0">{this.state.itemactionname} </h5>
              <button
                type="button"
                onClick={this.handleCkey}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">







              <AvForm
                className="needs-validation"
                onValidSubmit={this.handleValidFSSubmit}
              >
                {this.state.showAlert ? (
                  <Alert color={this.state.alertType}>
                    <p>{this.state.alertText}</p>
                  </Alert>
                ) : null}


                <div className="mb-3">
                  <AvField
                    name="tttname"
                    label="Fee Structure Name"
                    type="text"
                    required
                    placeholder={'Enter Fee Structure Name'}
                  />
                </div>


                <div className="mb-3">
                  <AvField
                    name="description"
                    label={this.state.itemdescriptionname}
                    type="text"
                    // required
                    placeholder={'Enter ' + this.state.itemdescriptionname}
                  />

                </div>

                <div className="mb-3">
                  <div className="form-group">
                    <AvField type="select" name="ftvalue" label="Fee Type" required>
                      {this.state.allfeetypes && this.state.allfeetypes.map((feetype, index) => {
                        return (
                          <option key={index} value={feetype.id}>{feetype.name}</option>
                        )
                      })}
                    </AvField>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="form-group">
                    <AvField type="select" name="ntvalue" label="Notification Type" required>
                      {this.state.allnotitypes && this.state.allnotitypes.map((notitype, index) => {
                        return (
                          <option key={index} value={notitype.id}>{notitype.name}</option>
                        )
                      })}
                    </AvField>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="form-group">
                    <AvField type="select" name="nivalue" label="Notification Intervel" required>
                      {this.state.allnotiintvals && this.state.allnotiintvals.map((notiintval, index) => {
                        return (
                          <option key={index} value={notiintval.id}>{notiintval.name}</option>
                        )
                      })}
                    </AvField>
                  </div>
                </div>



                <div className="mt-4 d-grid">
                  <button
                    className="btn btn-primary btn-block waves-effect waves-light"
                    type="submit"
                  >
                    {this.state.itemactionname}
                  </button>
                </div>


              </AvForm>



            </div>
          </Modal>
        </div>
      </React.Fragment>
    )
  }
}

export default SchAcademicStructure
